import { ApplicationReaction } from "@entities/reactions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SetNotificationsPayload } from "./types";

export interface NotificationsState {
  likes: ApplicationReaction[];
  matches: ApplicationReaction[];
  haveNew: boolean;
}

const initialState: NotificationsState = {
  likes: [],
  matches: [],
  haveNew: false,
};

export const NOTIFICATIONS_SLICE_KEY = "notifications";

export const notificationsSlice = createSlice({
  name: NOTIFICATIONS_SLICE_KEY,
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<SetNotificationsPayload>
    ) => {
      if (action.payload.recordType === "like")
        state.likes = action.payload.data;
      if (action.payload.recordType === "match")
        state.matches = action.payload.data;

      if (
        action.payload.data.length === 0 &&
        state.matches.length === 0 &&
        state.likes.length === 0
      )
        state.haveNew = false;
      else state.haveNew = true;
    },
  },
});

export const { setNotifications } = notificationsSlice.actions;
